export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معطل"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-EG": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معطل"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-SA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معطل"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-DE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-AT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-CH": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-US": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivated"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-GB": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivated"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "it-IT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivato"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-FR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "es-ES": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactivado"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pl-PL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezaktywowane"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "nl-NL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gedeactiveerd"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bg-BG": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивиран"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bs-BA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "da-DK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveret"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "et-EE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveeritud"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fi-FI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei käytössä"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-GR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήθηκε"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "he-IL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מושבת"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ga-IE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Díghníomhachtaithe"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ja-JP": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["無効"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hr-HR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lv-LV": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizēts"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lt-LT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjungta"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pt-PT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desativado"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ro-RO": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivat"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ru-RU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивировано"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sv-SE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inaktiverad"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sk-SK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivované"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "cs-CZ": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivováno"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-TR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakıldı"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hu-HU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiválva"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-BE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-LU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "mt-MT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diżattivat"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήθηκε"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakıldı"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "uk-UA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активовано"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вимкнено"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "zh-CN": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已停用"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      }
    }
  })
}
